import { useEffect, useState } from 'react';

/** The open project report announces itself so the floating header can show its title and Back. */
export type ReportHeaderState = { title: string; /** True on the reports home, where the header search filters the report list. */ searchable?: boolean } | null;
export function useReportHeaderState(): ReportHeaderState {
  const [state, setState] = useState<ReportHeaderState>(null);
  useEffect(() => {
    const onState = (event: Event) => setState((event as CustomEvent<ReportHeaderState>).detail ?? null);
    window.addEventListener('reports:header-state', onState);
    window.dispatchEvent(new CustomEvent('reports:request-header'));
    return () => window.removeEventListener('reports:header-state', onState);
  }, []);
  return state;
}
